module.exports = __webpack_public_path__ + "assets/protection.eb9d703f.svg";